import { Box } from '@coolblue-development/freddy';
import isPropValid from '@emotion/is-prop-valid';
import styled from '@emotion/styled';
export const Dot = styled(Box, {
    shouldForwardProp: prop => isPropValid(prop),
})(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '24px',
    height: '24px',
    cursor: 'pointer',
    boxSizing: 'border-box',
    borderRadius: '50%',
    border: `${theme.borderWidth[25]} solid ${theme.color.border.tertiary}`,
    backgroundColor: theme.color.background.backdropDimmed,
    zIndex: 0,
    '&:hover': {
        backgroundColor: theme.color.background.base,
        opacity: 1,
        '&::after': {
            backgroundColor: theme.color.icon.base,
        },
    },
    '&::after': {
        content: '""',
        zIndex: 1,
        width: '8px',
        height: '8px',
        backgroundColor: theme.color.icon.inverse,
        borderRadius: '50%',
    },
}));
export const PulseDot = styled(Box, {
    shouldForwardProp: prop => isPropValid(prop),
})(({ theme }) => ({
    width: '8px',
    height: '8px',
    borderRadius: '50%',
    background: theme.color.icon.base,
    cursor: 'pointer',
    outline: `${theme.borderWidth[25]} solid ${theme.color.border.base}`,
    '&::before, &::after': {
        content: '""',
        position: 'absolute',
        width: '8px',
        height: '8px',
        borderRadius: '50%',
        backgroundColor: theme.color.icon.base,
        transformOrigin: 'center center',
        animation: 'pulse-me 1.5s linear infinite',
    },
    '&::after': {
        animationDelay: '1s',
    },
    '@keyframes pulse-me': {
        '0%': {
            transform: 'scale(0.5)',
            opacity: '0',
        },
        '50%': {
            opacity: '0.6',
        },
        '70%': {
            opacity: '0.3',
        },
        '100%': {
            transform: 'scale(4)',
            opacity: '0',
        },
    },
    '@-webkit-keyframes pulse': {
        '50%': { opacity: '0.6' },
    },
}));
//# sourceMappingURL=Inspirational.styled.js.map